import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  AUTH_ERROR,
  CLEAR_AUTH_ERROR,
  UPDATE_CURRENT_USER
} from "./actionTypes"

export const loginUser = (user, navigate, isProfile) => {
  return {
    type: LOGIN_USER,
    payload: { user, navigate, isProfile },
  }
}

export const loginSuccess = user => {
  return {
    type: LOGIN_SUCCESS,
    payload: user,
  }
}

export const logoutUser = history => {
  return {
    type: LOGOUT_USER,
    payload: { history },
  }
}

export const logoutUserSuccess = () => {
  return {
    type: LOGOUT_USER_SUCCESS,
    payload: {},
  }
}

export const loginError = error => {
  return {
    type: AUTH_ERROR,
    payload: error,
  }
}

export const clearAuthError = () => {
  return {
    type: CLEAR_AUTH_ERROR,
    payload: {},
  }
}

export const updateCurrentUser = (updatedUser) => {
  return {
    type: UPDATE_CURRENT_USER,
    payload: updatedUser,
  }
}